<template>
  <v-content>
    <v-hover v-slot:default="{ hover }" open-delay="50" style="cursor: pointer">
      <v-card flat width="500" height="auto">
        <!-- Size SM and Up -->
        <v-img
          v-if="$vuetify.breakpoint.smAndUp"
          aspect-ratio="1"
          :src="
            imageCover
              ? url + imgPath + 'images_cover/' + imageCover
              : require('../../assets/tcdc-color.png')
          "
          class="white--text align-end"
          max-height="300"
          height="auto"
          :contain="imageCover ? false : true"
        >
          <v-expand-transition>
            <div
              v-if="hover"
              class="d-flex transition-fast-in-fast-out black darken-2 v-card--reveal display-3 white--text"
              style="height: 100%;"
            >
              <span
                style="font-size: 16px;font-weight: bold"
                class="text-uppercase"
                >see detail</span
              >
            </div>
          </v-expand-transition>
        </v-img>

        <!-- Size mobile -->
        <v-img
          v-else
          :src="
            imageCover
              ? url + imgPath + 'images_cover/' + imageCover
              : require('../../assets/tcdc-color.png')
          "
          class="white--text align-end"
          aspect-ratio="1"
          max-height="430"
          height="auto"
          :contain="imageCover ? false : true"
        >
          <v-expand-transition>
            <div
              v-if="hover"
              class="d-flex transition-fast-in-fast-out black darken-2 v-card--reveal display-3 white--text"
              style="height: 100%;"
            >
              <span
                style="font-size: 16px;font-weight: bold"
                class="text-uppercase"
                >see detail</span
              >
            </div>
          </v-expand-transition>
        </v-img>

        <v-card-actions>
          <v-layout>
            <v-flex shrink class="d-flex align-center mr-3">
              <v-img
                v-if="$vuetify.breakpoint.smAndUp"
                style="border-radius: 100%"
                :src="
                  imageProfile
                    ? url + imgPath + 'images_profile/' + imageProfile
                    : require('../../assets/user_profile.png')
                "
                class="white--text align-end"
                gradient="to bottom, rgba(0,0,0,.1), rgba(0,0,0,.5)"
                width="30px"
                height="30px"
              >
              </v-img>
              <v-img
                v-else
                style="border-radius: 100%"
                :src="
                  imageProfile
                    ? url + imgPath + 'images_profile/' + imageProfile
                    : require('../../assets/user_profile.png')
                "
                class="white--text align-end"
                gradient="to bottom, rgba(0,0,0,.1), rgba(0,0,0,.5)"
                width="40px"
                height="40px"
              >
              </v-img>
            </v-flex>
            <v-flex>
              <v-layout>
                <v-flex>
                  <div
                    class="one-line"
                    v-if="$vuetify.breakpoint.lgAndUp"
                    :style="{ 'font-size': fontLg + 'px' }"
                  >
                    {{ title }}
                  </div>
                  <div
                    class="one-line"
                    v-if="$vuetify.breakpoint.md"
                    :style="{ 'font-size': fontMd + 'px' }"
                  >
                    {{ title }}
                  </div>
                  <div
                    class="one-line"
                    v-if="$vuetify.breakpoint.smAndDown"
                    :style="{ 'font-size': fontSm + 'px' }"
                  >
                    {{ title }}
                  </div>
                </v-flex>
              </v-layout>
              <v-layout>
                <v-flex>
                  <div
                    class="one-line"
                    v-if="$vuetify.breakpoint.lgAndUp"
                    :style="{ 'font-size': fontLg - 2 + 'px' }"
                  >
                    {{ $t("by") }} {{ by ? checkName(by) : "" }}
                  </div>
                  <div
                    class="one-line"
                    v-if="$vuetify.breakpoint.md"
                    :style="{ 'font-size': fontMd - 1 + 'px' }"
                  >
                    {{ $t("by") }} {{ by ? checkName(by) : "" }}
                  </div>
                  <div
                    class="one-line"
                    v-if="$vuetify.breakpoint.smAndDown"
                    :style="{ 'font-size': fontSm - 1 + 'px' }"
                  >
                    {{ $t("by") }} {{ by ? checkName(by) : "" }}
                  </div>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
        </v-card-actions>
      </v-card>
    </v-hover>
    <!--        <loading-->
    <!--                color="#FD5246"-->
    <!--                :active.sync="isLoading"-->
    <!--                :can-cancel="false"-->
    <!--                :is-full-page="false"-->
    <!--        ></loading>-->
  </v-content>
</template>

<script>
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import { domain, imgPath } from "../../services/Constants";

export default {
  components: {
    Loading,
  },
  name: "CardContent",
  props: {
    title: {
      type: String,
    },
    width: {
      type: String,
    },
    height: {
      type: String,
    },
    imageCover: {
      type: String,
    },
    imageProfile: {
      type: String,
    },
    by: {
      type: Object,
    },
    fontLg: {
      type: String,
      default: "11",
    },
    fontMd: {
      type: String,
      default: "11",
    },
    fontSm: {
      type: String,
      default: "13",
    },
    isLoading: {
      type: Boolean,
      default: true,
    },
  },
  data: () => ({
    imgPath: imgPath,
    url: domain,
    // isLoading: false,
    // fullPage: true,
  }),
  methods: {
    checkName(val) {
      if (val.name_th && val.last_th) {
        if (val.name_th.length > 15) {
          return val.name_th;
        } else {
          return val.name_th + " " + val.last_th;
        }
      } else if (val.name_th && !val.last_th) {
        return val.name_th;
      } else if (val.name_en && val.last_en) {
        if (val.name_en.length > 15) {
          return val.name_en;
        } else {
          return val.name_en + " " + val.last_en;
        }
      } else if (val.name_en && !val.last_en) {
        return val.name_en;
      } else {
        return val.email;
      }
    },
  },
};
</script>

<style lang="scss">
.v-card--reveal {
  align-items: center;
  bottom: 0;
  justify-content: center;
  opacity: 0.65;
  position: absolute;
  width: 100%;
}

.v-responsive.v-image.img-content-cover {
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
}

.img-cover-by {
  border-radius: 100%;
  max-height: 100%;
  max-width: 100%;
  height: 100%;
  object-fit: cover;
  width: 100%;
}
</style>
